import { useState } from 'react';

import PropTypes from 'prop-types';

import styles from './MobileCommentSection.module.scss';

/**
 * 모바일 코멘트 섹션 컴포넌트
 * - 피그마 디자인: 접기/펼치기 + "코멘트 선택" 버튼
 */
function MobileCommentSection({ comments, showWriteButton, onWriteClick, onCommentClick }) {
  const [isOpen, setIsOpen] = useState(true);

  const hasComments = comments && comments.length > 0;

  function toggleSection() {
    setIsOpen(!isOpen);
  }

  return (
    <div className={styles.container}>
      <div className={styles.sectionHeader}>
        <button type="button" className={styles.titleButton} onClick={toggleSection}>
          <span className={styles.sectionTitle}>코멘트</span>
          <svg
            className={`${styles.chevron} ${isOpen ? styles.open : ''}`}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M6 7.5L9 10.5L12 7.5"
              stroke="#828282"
              strokeWidth="1.33"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* 코멘트 선택(작성) 버튼 - showWriteButton이 true일 때만 표시 */}
        {showWriteButton && (
          <button type="button" className={styles.writeButton} onClick={onWriteClick}>
            코멘트 선택
          </button>
        )}
      </div>

      {isOpen && (
        <div className={styles.commentList}>
          {!hasComments ? (
            <div className={styles.emptyMessage}>등록된 코멘트가 없습니다.</div>
          ) : (
            comments.map(function (comment, index) {
              const commentText = comment.comment || comment.content || '';
              const authorName = comment.name || '익명';

              return (
                <button
                  key={`comment-${comment.idx || index}`}
                  type="button"
                  className={styles.commentItem}
                  onClick={function () {
                    if (onCommentClick) {
                      onCommentClick(comment);
                    }
                  }}
                >
                  <div className={styles.commentInfo}>
                    <span className={styles.commentText}>{commentText}</span>
                    <span className={styles.commentAuthor}>{authorName}</span>
                  </div>
                  {/* 오른쪽 화살표 */}
                  <svg
                    className={styles.arrowIcon}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M6 4L10 8L6 12"
                      stroke="#424242"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}

MobileCommentSection.propTypes = {
  comments: PropTypes.array,
  showWriteButton: PropTypes.bool,
  onWriteClick: PropTypes.func,
  onCommentClick: PropTypes.func,
};

MobileCommentSection.defaultProps = {
  comments: [],
  showWriteButton: false,
  onWriteClick: null,
  onCommentClick: null,
};

export default MobileCommentSection;
